// BabyReveal.js — the gender reveal held on 11 September 2026.
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaImages, FaHeart } from 'react-icons/fa';
import VideoReveal from '../common/VideoReveal';
import { EVENT_VIDEOS } from '../../config/eventVideos';
import revealImage from '../../images/baby/gender-reveal.jpg';
import './BabyReveal.css';

// Read from the shared list rather than a local constant, so the id is set in
// one place and this page and the home video section can never disagree.
const revealEvent = EVENT_VIDEOS.find(e => e.key === 'babyReveal');

const BabyReveal = () => {
  const { t } = useTranslation();

  return (
    <div className="baby-reveal-page">
      <section className="baby-reveal-hero">
        <img
          src={revealImage}
          alt={t('babyReveal.imageAlt', 'Rosa konfetti i lufta under baby reveal')}
          className="baby-reveal-hero-img"
        />
        <div className="baby-reveal-hero-scrim" />

        <div className="baby-reveal-hero-content">
          <p className="baby-reveal-kicker">
            {t('babyReveal.kicker', 'Overraskelsen')}
          </p>
          <h1>{t('babyReveal.title', 'Det ble en jente!')}</h1>
          <p className="baby-reveal-date">
            {t('babyReveal.date', '11. september 2026')}
          </p>
        </div>
      </section>

      <section className="baby-reveal-body">
        <p className="baby-reveal-story">
          {t(
            'babyReveal.story',
            'Familie og venner samlet seg, konfettikanonene gikk av, og rosa fylte rommet. Vi venter en liten jente.'
          )}
        </p>

        <div className="baby-reveal-video-wrap">
          <VideoReveal
            youtubeId={revealEvent?.youtubeId}
            image={revealImage}
            objectPosition={revealEvent?.objectPosition}
            title={t('babyReveal.videoTitle', 'Baby reveal-video')}
            label={t('babyReveal.watchReveal', 'Se øyeblikket')}
          />
        </div>

        <div className="baby-reveal-actions">
          <Link to="/photos" className="baby-reveal-btn primary">
            <FaImages aria-hidden /> {t('babyReveal.viewPhotos', 'Se bildene')}
          </Link>
          <Link to="/wishes" className="baby-reveal-btn">
            <FaHeart aria-hidden /> {t('babyReveal.leaveWish', 'Skriv en hilsen')}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default BabyReveal;
